export const SubsidiaryCell = (subsidiaries) => ({ original }) => {
    const id = original?.invocationExtraData?.subsidiaryId;
    const item = subsidiaries.find((item) => item.subsidiaryId === id);
    return (item && item.subsidiaryName) || '-';
  };
